import React from 'react';

import type { ProductDetailsScreenProps } from '../../navigation/AppNavigation.props';
import { CustomizationV2, ProductDetails } from './components';
import { usePdpV2QueryEnabled } from './hooks';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsScreen = ({
  navigation,
  route,
}: ProductDetailsScreenProps) => {
  const {
    restaurantSlug,
    productSlug,
    ingredientIds,
    name: encodedName,
    reorderLineItemId,
  } = route.params ?? {};

  const isPdpV2QueryEnabled = usePdpV2QueryEnabled();

  const name = encodedName ? decodeURIComponent(encodedName) : null;
  const decodedIngredientIds = ingredientIds
    ? decodeURIComponent(ingredientIds)
    : null;

  const handleAddLineItemToCart = React.useCallback(() => {
    navigation.replace('Bag', { referrer: 'Menu' });
  }, [navigation]);

  // ─── New Version ─────────────────────────────────────────────────────

  if (isPdpV2QueryEnabled) {
    return (
      <CustomizationV2
        restaurantSlug={restaurantSlug}
        productSlug={productSlug}
        onAddLineItemToCart={handleAddLineItemToCart}
        reorderLineItemId={reorderLineItemId}
        isEditProductMode={false}
      />
    );
  }

  // ─────────────────────────────────────────────────────────────────────

  return (
    <ProductDetails
      restaurantSlug={restaurantSlug}
      productSlug={productSlug}
      ingredientIds={decodedIngredientIds?.split(',')}
      onAddLineItemToCart={handleAddLineItemToCart}
      reorderLineItemId={reorderLineItemId}
      // @ts-expect-error TS(2322): Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
      name={name}
    />
  );
};
